import { IconXFilled } from '@tabler/icons-react';

export default function CancelarPedidoButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Cancelar pedido"
      title="Cancelar pedido"
      className="flex items-center justify-center shrink-0 w-12 h-12 rounded-full border-none cursor-pointer touch-manipulation select-none transition-all duration-200 ease-out active:scale-[0.96] [@media(hover:hover)]:hover:brightness-110"
      style={{
        backgroundColor: '#ff453a',
        boxShadow: '0 6px 18px rgba(255, 69, 58, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.18)',
      }}
    >
      <IconXFilled size={18} color="#fff" />
    </button>
  );
}
